import { DateTime } from "luxon";
import { TCasesDayViewForm } from "../../../domain/codecs/form/CasesForm";

export type TDayViewDateFilter = TCasesDayViewForm["edited"]["filters"]["date"];
export type TDayViewAssigneeFilter = TCasesDayViewForm["edited"]["filters"]["assigned_to"];

export const hasAssigneeLeftTheDayList = (filter: TDayViewAssigneeFilter, assignedToUserId: string): boolean =>
    filter !== null && filter !== assignedToUserId;

export const hasDateLeftTheDayList = (filter: TDayViewDateFilter, date: string | null): boolean => {
    if (date === null) {
        return true;
    }

    const movedTo = DateTime.fromISO(date, { zone: "utc" });

    if (!movedTo.isValid) {
        return false;
    }

    const movedToIsoDate = movedTo.toFormat("yyyy-MM-dd");

    return filter.type === "iso"
        ? movedToIsoDate !== filter.date
        : movedToIsoDate >= DateTime.utc().setZone("Europe/London").toISODate();
};
